<template>
  <zul-modal id="masterpass-modal" ref="modal" title="Masterpass">
    <div v-if="connecting || !connectUrl">
      <div class="loading">
        Conectando Masterpass...
      </div>
    </div>
    <div v-else>
      <h2 v-if="product" class="is-big is-centered">Contratar: <strong class="is-primary">{{ product.title}}</strong></h2>

      <div v-if="redeem" class="is-centered">
        <p class="is-price">{{ redeem.discount }}*</p>
        <p v-html="redeem.notes"></p>
      </div>

      <p v-if="redeem">Crie gratuitamente uma conta <strong>Masterpass</strong> e receba esse desconto promocional, utilizando o <strong>cartão de crédito</strong> de sua preferência.</p>
      <p v-else>Crie gratuitamente uma conta <strong>Masterpass</strong> e utilize o <strong>cartão de crédito</strong> de sua preferência.</p>

      <p class="is-centered">
        <img src="../../public/img/cards.png" alt="Aceita cartões Mastercard, Visa, Amex e Dinners">
      </p>

      <p>Masterpass é uma carteira digital que permite executar pagamentos online com rapidez, agilidade e segurança.</p>

      <p v-if="redeem"><strong>Conecte a sua conta agora e aproveite o desconto, é rápido:</strong></p>
      <p v-else><strong>Conecte a sua conta agora, é rápido:</strong></p>

      <a @click="connect()" class="is-centered"><img src="../../public/img/masterpass.png" alt=""></a>

      <p v-if="message">{{ message }}</p>
    </div>

  </zul-modal>
</template>

<script>
//import MasterPass from 'masterpass'

export default {
  props: {},
  data () {
    return {
      product: null,
      redeem: null,
      connectUrl: null,
      connecting: false,
      connected: false,
      message: null
    }
  },
  mounted () {
    this.$root.$on('open-masterpass-modal', (data) => {
      this.product = data && data.product
      this.redeem = data && data.redeem

      this.$refs.modal.open()
      this.$http.get('/wallet/masterpass/connect' + `?callback=${window.location.origin}/return/masterpass-connect`).then(res => {
        this.connectUrl = res.data
        this.connecting = false
      })
    })
    this.$root.$on('close-masterpass-modal', () => {
      this.close()
      this.connecting = false
    })

    this.$root.$on('masterpass-connect-init', () => {
      this.connected = false
      this.connecting = true
      this.message = null
    }),

    this.$root.$on('masterpass-connect-end', (response) => {
      if(response.success === 'true') {
        this.connected = true

        let data = new FormData()
        data.append('token', response.token)
        data.append('gateway', 'MASTERPASS')
        data.append('allowOverride', true)

        this.$http.post('/user/payment', data).then( res => {
          this.$root.masterpassConnected = true
          this.$root.masterpassCurrentCard = res.data

          this.$root.$emit('close-masterpass-modal')
        }, () => {
          this.connecting = false
          this.message = 'Não foi possível conectar sua conta Masterpass, tente novamente.'
        })
      } else {
        this.connecting = false
        this.message = 'Não foi possível conectar sua conta Masterpass, tente novamente.'
      }
      
    })
    //this.$root.$on('reset-masterpass-modal', this.reset)
  },
  destroyed () {
    this.$root.$off('open-masterpass-modal')
    this.$root.$off('close-masterpass-modal')
    this.$root.$off('reset-masterpass-modal')
    this.$root.$off('masterpass-connect-init')
    this.$root.$off('masterpass-connect-end')
  },
  methods: {
    connect() {
      window.open(this.connectUrl)
      this.$root.$emit('masterpass-connect-init')
    },
    close() {
      this.$refs.modal.close()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';

  p {
    margin-bottom: 18px;
  }

  @each $city, $map in $cities {
    .is-#{$city} .is-primary {
      color: map-get($map, 'primary') !important;
    }            
  }

  .is-big {
    font-size: 22px;
    margin-bottom: 18px;
  }

  .is-price {
    color: $primary !important;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 0;
  }

  .is-centered {
    display: block;
    text-align: center;
  }

</style>